
import { TranslationSet } from '../types';

export const entries: TranslationSet = {
  'entries.title': {
    en: 'Entries',
    ja: '記録',
    es: 'Entradas',
    zh: '日记',
    fa: 'یادداشت‌ها'
  },
  'entries.sharedTitle': {
    en: 'Shared Entry',
    ja: '共有エントリ',
    es: 'Entrada compartida',
    zh: '分享的条目',
    fa: 'یادداشت اشتراک‌گذاری شده'
  },
  'entries.sharedSubtitle': {
    en: 'This entry was shared with you!',
    ja: 'このエントリはあなたと共有されました！',
    es: '¡Esta entrada fue compartida contigo!',
    zh: '这个条目已经与你分享！',
    fa: 'این یادداشت با شما به اشتراک گذاشته شده است!'
  },
  'entries.emptyState': {
    en: 'No entries yet. Start capturing your baby\'s milestones!',
    ja: 'まだエントリはありません。赤ちゃんのマイルストーンを記録しましょう！',
    es: 'Aún no hay entradas. ¡Comienza a capturar los hitos de tu bebé!',
    zh: '还没有条目。开始记录宝宝的里程碑！',
    fa: 'هنوز هیچ یادداشتی وجود ندارد. شروع به ثبت لحظات مهم کودک خود کنید!'
  },
  'entries.entryCard.createdAt': {
    en: 'Created At',
    ja: '作成日',
    es: 'Creado el',
    zh: '创建于',
    fa: 'ایجاد شده در'
  },
  'entries.entryCard.updatedAt': {
    en: 'Updated At',
    ja: '更新日',
    es: 'Actualizado el',
    zh: '更新于',
    fa: 'به‌روزرسانی شده در'
  },
  'entries.entryCard.dateFormat': {
    en: 'MMMM dd, yyyy',
    ja: 'yyyy年MM月dd日',
    es: 'dd de MMMM, yyyy',
    zh: 'yyyy年MM月dd日',
    fa: 'dd MMMM, yyyy'
  },
  'entries.todaysTips.title': {
    en: 'Today\'s Baby Tips',
    ja: '今日の育児のヒント',
    es: 'Consejos para el bebé de hoy',
    zh: '今日育儿小贴士',
    fa: 'نکات امروز کودک'
  },
  'entries.todaysTips.tip1': {
    en: 'Remember to talk to your baby throughout the day to help develop language skills.',
    ja: '言語スキルの発達を助けるために、一日を通して赤ちゃんに話しかけましょう。',
    es: 'Recuerda hablar con tu bebé durante todo el día para ayudar a desarrollar las habilidades lingüísticas.',
    zh: '记得全天和宝宝交谈，以帮助发展语言能力。',
    fa: 'به یاد داشته باشید در طول روز با کودک خود صحبت کنید تا به توسعه مهارت‌های زبانی کمک کنید.'
  },
  'entries.todaysTips.tip2': {
    en: 'Skin-to-skin contact helps regulate your baby\'s body temperature and heart rate.',
    ja: '肌と肌の接触は、赤ちゃんの体温と心拍数の調節に役立ちます。',
    es: 'El contacto piel con piel ayuda a regular la temperatura corporal y el ritmo cardíaco de tu bebé.',
    zh: '肌肤接触有助于调节宝宝的体温和心率。',
    fa: 'تماس پوست با پوست به تنظیم دمای بدن و ضربان قلب کودک شما کمک می‌کند.'
  },
  'entries.todaysTips.tip3': {
    en: 'Tummy time helps strengthen your baby\'s neck, back, and shoulder muscles.',
    ja: 'うつ伏せの時間は、赤ちゃんの首、背中、肩の筋肉を強化するのに役立ちます。',
    es: 'El tiempo boca abajo ayuda a fortalecer los músculos del cuello, la espalda y los hombros de tu bebé.',
    zh: '俯卧时间有助于增强宝宝的颈部、背部和肩部肌肉。',
    fa: 'زمان روی شکم خوابیدن به تقویت عضلات گردن، پشت و شانه کودک شما کمک می‌کند.'
  },
  'entries.yourDiaryEntries': {
    en: 'Your Diary Entries',
    ja: 'あなたの日記エントリ',
    es: 'Tus Entradas de Diario',
    zh: '你的日记条目',
    fa: 'یادداشت‌های دفتر خاطرات شما'
  },
  'entries.browseAndManage': {
    en: 'Browse and manage your baby\'s diary entries',
    ja: '赤ちゃんの日記エントリを閲覧・管理する',
    es: 'Navega y administra las entradas del diario de tu bebé',
    zh: '浏览和管理宝宝的日记条目',
    fa: 'مرور و مدیریت یادداشت‌های دفتر خاطرات کودک شما'
  },
  'entries.searchEntries': {
    en: 'Search entries...',
    ja: 'エントリを検索...',
    es: 'Buscar entradas...',
    zh: '搜索条目...',
    fa: 'جستجوی یادداشت‌ها...'
  },
  'entries.newEntry': {
    en: 'New Entry',
    ja: '新規エントリ',
    es: 'Nueva Entrada',
    zh: '新条目',
    fa: 'یادداشت جدید'
  },
  'entries.entryCalendar': {
    en: 'Entry Calendar',
    ja: 'エントリカレンダー',
    es: 'Calendario de Entradas',
    zh: '条目日历',
    fa: 'تقویم یادداشت‌ها'
  },
  'entries.clearFilter': {
    en: 'Clear filter',
    ja: 'フィルターをクリア',
    es: 'Borrar filtro',
    zh: '清除筛选',
    fa: 'پاک کردن فیلتر'
  },
  'entries.noEntriesFound': {
    en: 'No entries found',
    ja: 'エントリが見つかりません',
    es: 'No se encontraron entradas',
    zh: '未找到条目',
    fa: 'هیچ یادداشتی یافت نشد'
  },
  'entries.noEntriesMatch': {
    en: 'No entries match your search criteria',
    ja: '検索条件に一致するエントリはありません',
    es: 'No hay entradas que coincidan con tus criterios de búsqueda',
    zh: '没有符合您搜索条件的条目',
    fa: 'هیچ یادداشتی با معیارهای جستجوی شما مطابقت ندارد'
  },
  'entries.noEntriesYet': {
    en: 'You haven\'t created any diary entries yet',
    ja: 'まだ日記エントリを作成していません',
    es: 'Aún no has creado ninguna entrada de diario',
    zh: '您尚未创建任何日记条目',
    fa: 'شما هنوز هیچ یادداشت روزانه‌ای ایجاد نکرده‌اید'
  },
  'entries.createFirstEntry': {
    en: 'Create your first entry',
    ja: '最初のエントリを作成',
    es: 'Crear tu primera entrada',
    zh: '创建您的第一个条目',
    fa: 'اولین یادداشت خود را ایجاد کنید'
  },
  'entries.showingPage': {
    en: 'Showing page',
    ja: 'ページ表示中',
    es: 'Mostrando página',
    zh: '显示页面',
    fa: 'نمایش صفحه'
  },
  'entries.previous': {
    en: 'Previous',
    ja: '前へ',
    es: 'Anterior',
    zh: '上一页',
    fa: 'قبلی'
  },
  'entries.next': {
    en: 'Next',
    ja: '次へ',
    es: 'Siguiente',
    zh: '下一页',
    fa: 'بعدی'
  }
};
